import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js'
import {Bar} from 'react-chartjs-2'

ChartJS.register(ArcElement, Tooltip, Legend)

interface ChartAreaProps {
  reports: any
}

const options = {
  responsive: true,
  borderRadius: 100,
  barThickness: 20,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
}

const BarChart: React.FC<ChartAreaProps> = ({reports}) => {
  if (!reports.labels || !reports.datasets) {
    return null
  }

  return <Bar data={reports} options={options} />
}

export default BarChart
